export const EMAIL_FORMAT_ERROR = "El formato del correo electrónico no es válido";
export const EMAIL_REQUIRED_ERROR = "Este campo es requerido.";
export const EMAIL_VERIFICATION_ERROR =
  "No se pudo validar el correo electrónico. Intenta nuevamente.";
export const EMAIL_SAVE_ERROR =
  "No se puede guardar la solicitud. Revisa la validación del correo electrónico del representante legal.";
